import { render } from "./BuyTickets.vue?vue&type=template&id=6dd7379e"
import script from "./BuyTickets.vue?vue&type=script&lang=js"
export * from "./BuyTickets.vue?vue&type=script&lang=js"

import "./BuyTickets.vue?vue&type=style&index=0&id=6dd7379e&lang=css"
script.render = render

export default script